import React from "react";

import {
  Card,
  CardContent,
  CardActionArea,
  Typography,
} from "@mui/material";
import { AddCircle } from "@mui/icons-material";

interface NewSelectionCardProps {
  onClick: () => void;
}

const NewSelectionCard: React.FC<NewSelectionCardProps> = ({
  onClick,
}) => {

  return (
    <Card
      variant="outlined"
      sx={{
        background: "transparent",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // width: 280,
        height: "auto",
        flexShrink: 0
      }}
    >
      <CardActionArea
        onClick={onClick}
        sx={{ flexGrow: 1 }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            flexGrow: 1
          }}
        >
          <AddCircle color="info" />
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default NewSelectionCard;
